__turbopack_context__.v({
  "className": "big_shoulders_46451cc6-module__CdoAha__className",
  "variable": "big_shoulders_46451cc6-module__CdoAha__variable",
});
